export const doctorCards = [
  {
    id: 1,
    name: 'Dr. Sandeep Sharma',
    role: 'Senior Consultant — Orthopedics & Joint Reconstruction',
    specialization: 'Trauma management, joint preservation, arthroplasty & Ilizarov techniques',
    experience: '18+ Years',
    education: 'MBBS, MS (Orthopedics), Depuy Synthes Joint Replacement Fellowship',
    image: '/assets/onedrive/sandeep sharma.png',
    achievements: [
      'Trained under Dr. S. M. Sharma at Sharma Orthopedic Centre',
      'Member: IOA, ROSA, ASAMI, LRS Rajasthan, NAILS',
      'Leads complex deformity correction & limb salvage programs',
      'Extensive experience in arthroplasty and trauma care'
    ],
    expertise: ['Complex Trauma & Intra-articular Fractures', 'Joint Preservation', 'Hip & Knee Arthroplasty', 'Ilizarov Reconstruction'],
    contact: {
      email: 'dr.sandeep@sharmaortho.com',
      phone: '+91-77270-48951',
      linkedin: 'dr-sandeep-sharma'
    },
    availability: 'Tue-Sun: 10 AM - 6 PM',
    languages: ['English', 'Hindi']
  },
  {
    id: 2,
    name: 'Dr. Ajay Singh Khara',
    role: 'Lead Anaesthesiologist & Perioperative Specialist',
    specialization: 'General and regional anaesthesia, difficult airway & critical care',
    experience: '17+ Years',
    education: 'MBBS (SMS Jaipur), MD Anaesthesiology (RNT Udaipur)',
    image: '/assets/onedrive/ajay singh kharra.png',
    achievements: [
      'Expert in general anaesthesia for surgical & critical care procedures',
      'Specialist in difficult airway management & intubations',
      'Advanced regional block techniques for surgery & pain',
      'Trusted perioperative partner across SOCH theatres'
    ],
    expertise: ['General Anaesthesia', 'Regional/Nerve Blocks', 'Critical Care & Monitoring', 'Pain Management'],
    contact: {
      email: 'dr.ajay@sharmaortho.com',
      phone: '+91-77270-48951',
      linkedin: 'dr-ajay-singh-khara'
    },
    availability: 'Wed-Mon: 9:30 AM - 6:30 PM',
    languages: ['English', 'Hindi']
  },
  {
    id: 3,
    name: 'Dr. Ali Hasan',
    role: 'Consultant Orthopedic Surgeon — Trauma, Arthroplasty & Arthroscopy',
    specialization: 'Knee preservation, arthroplasty, minimally invasive trauma & limb reconstruction',
    experience: '15+ Years',
    education: 'MBBS (Madurai), MS Orthopedics (Dr. S. N. Medical College, Jodhpur)',
    image: '/assets/onedrive/Ali hassan.png',
    achievements: [
      'Consultant at S. K. Soni Hospital & S. K. Govt. District Hospital',
      'Member: IOA, ROSA, ASAMI & Limb Reconstruction Society of Rajasthan',
      'Specializes in MIS/MIPPO, Ilizarov & deformity correction',
      'Leads revision surgeries for nonunion, malunion & infection'
    ],
    expertise: ['Knee Preservation & Arthroplasty', 'Minimally Invasive Trauma', 'Ilizarov & LRS Reconstruction', 'Complex Trauma Management'],
    contact: {
      email: 'dr.ali@sharmaortho.com',
      phone: '+91-77270-48951',
      linkedin: 'dr-ali-hassan'
    },
    availability: 'Mon-Fri: 11 AM - 5 PM',
    languages: ['English', 'Hindi', 'Urdu']
  },
  {
    id: 4,
    name: 'Dr. Manish Jangir',
    role: 'Consultant — Sports Medicine & Arthroscopy',
    specialization: 'Knee & shoulder arthroscopy, sports injuries & shoulder replacement',
    experience: '12+ Years',
    education: 'MBBS (GMC Miraj), MS Orthopedics (SMS Jaipur), FNB Sports Medicine & Arthroscopy',
    image: '/assets/onedrive/manish jangir.png',
    achievements: [
      'Completed senior residency in Orthopedics with advanced sports exposure',
      'FNB superspecialization in sports injuries & arthroscopy',
      'Expert in reverse & total shoulder arthroplasty',
      'Trusted mentor for athletes across Rajasthan'
    ],
    expertise: ['Knee Arthroscopy (ACL/PCL/MCL/PLC)', 'Meniscus & Cartilage Surgery', 'Shoulder Arthroscopy & Rotator Cuff Repair', 'Shoulder Replacement & Sports Injury Rehab'],
    contact: {
      email: 'dr.manish@sharmaortho.com',
      phone: '+91-77270-48951',
      linkedin: 'dr-manish-jangir'
    },
    availability: 'Mon-Sat: 10 AM - 4 PM',
    languages: ['English', 'Hindi', 'Marwari']
  }
];


